import { useState } from "react";
import { encodeId, setStorage } from "utils";
import constants from "../../../../constants";

const useCardModule = () => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isCompletionModalOpen, setIsCompletionModalOpen] = useState(false);

  const handleToggle = () => {
    setIsConfirmModalOpen((prev) => !prev);
  };

  const handleCompletionModal = () => {
    setIsCompletionModalOpen((prev) => !prev);
  };

  const handleCardClick = (e, officePolicy, history, isfromDashBOard = false) => {
    if (e.target.closest(".interactive-element")) return;
    if (isfromDashBOard) setStorage("isChatFromDashBoard", true);
    history.push({
      pathname: constants.routes.officePolicyManagements.officePolicyManagementDetails.replace(
        ":officePolicyId",
        encodeId(officePolicy?.id)
      ),
      state: officePolicy,
    });
  };

  return {
    data: {
      isConfirmModalOpen,
      isCompletionModalOpen,
    },
    methods: {
      handleToggle,
      handleCardClick,
      handleCompletionModal,
    },
  };
};

export default useCardModule;
